module.exports = __webpack_public_path__ + "img/login_bg.4bb8c3fd.png";